// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"203":"5ec01bd6","453":"c46c10cd","520":"b68f18dc","659":"02d3b009","700":"e1afe159","811":"a526eef7","829":"81a17dfe","901":"bffd002d","936":"8a0327b1"}[chunkId] + ".chunk.js";
};